import React from 'react';

const ScaleRating = ({ value, onChange, min = 1, max = 10, disabled, type = 'rating_10' }) => {
  const options = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  const getBgColor = (num) => {
    if (value === num) {
      if (num <= 3) return 'bg-rose-600 text-white border-rose-600 shadow-rose-200';
      if (num <= 6) return 'bg-amber-500 text-white border-amber-500 shadow-amber-200';
      if (num <= 8) return 'bg-emerald-500 text-white border-emerald-500 shadow-emerald-200';
      return 'bg-green-600 text-white border-green-600 shadow-green-200';
    }
    return 'bg-white text-slate-700 border-slate-200 hover:border-adium-red hover:bg-red-50';
  };

  return (
    <div className="flex flex-col items-center py-4 w-full">
      <div className="flex flex-wrap justify-center gap-2 sm:gap-3 w-full max-w-xl">
        {options.map((num) => (
          <button
            key={num}
            type="button"
            disabled={disabled}
            onClick={() => onChange(num)}
            className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl font-bold border-2 transition-all duration-200 transform hover:scale-110 flex items-center justify-center cursor-pointer shadow-sm ${getBgColor(num)}`}
          >
            {num}
          </button>
        ))}
      </div>

      <div className="flex justify-between w-full max-w-xl px-2 mt-3 text-xs font-medium text-slate-500">
        <span>{type === 'nps' ? '0 - Improbable' : `${min} - Mínimo`}</span>
        <span>{max} - Sobresaliente</span>
      </div>
    </div>
  );
};

export default ScaleRating;
